import React from 'react';
import { Box, OutlinedInput, InputLabel, FormControl, IconButton } from '@mui/material';
import SendRoundedIcon from '@mui/icons-material/SendRounded';

interface ChatInputProps {
    input: string;
    setInput: (value: string) => void;
    handleSend: (value: string) => void;
}

const ChatInput: React.FC<ChatInputProps> = ({ input, setInput, handleSend }) => {
    const onSend = () => {
        if (input.trim()) {
            handleSend(input);
        }
    };

    return (
        <Box sx={{ p: 2, backgroundColor: 'background.paper', borderTop: '1px solid', borderColor: 'divider' }}>
            <FormControl fullWidth variant="outlined" sx={{
                position: 'relative',
                bgcolor: 'background.default',
                borderRadius: '25px',
            }}>
                <InputLabel htmlFor="chat-input" sx={{
                    position: 'absolute',
                    top: -10,
                    left: 10,
                    bgcolor: 'background.paper',
                    px: 0.5,
                    fontSize: '0.75rem',
                    fontWeight: 600,
                    color: 'text.secondary'
                }}>
                    Pregunta a Null-e
                </InputLabel>
                <OutlinedInput
                    id="chat-input"
                    fullWidth
                    autoComplete="off"
                    onChange={(e) => setInput(e.target.value)}
                    value={input}
                    placeholder='Escribe tu pregunta...'
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' && !e.shiftKey) {
                            e.preventDefault();
                            onSend();
                        }
                    }}
                    endAdornment={
                        <IconButton edge="end" onClick={onSend} color="primary">
                            <SendRoundedIcon />
                        </IconButton>
                    }
                    sx={{
                        pr: 0.5,
                        '& .MuiOutlinedInput-notchedOutline': {
                            border: 'none'
                        },
                        '& input::placeholder': {
                            color: 'text.disabled'
                        }
                    }}
                />
            </FormControl>
        </Box>
    );
};

export default ChatInput;